/* Gaveinnpakning V1 (28.10.2026). Avkrysning legger til / fjerner innpakningen
   (alltid antall 1), gavehilsen lagres som linjeegenskapen «Gavehilsen»
   underveis mens kunden skriver. Står innpakningen alene i kurven (siste vare
   fjernet), fjernes den også. Har innpakningen fått antall over 1 eller flere
   linjer, ryddes det til én linje med antall 1. Trykker kunden «Til kassen»
   mens hilsenen lagres, ventes lagringen ferdig først.
   Etter endring: skuffen tegnes på nytt via g9-cart-drawer.refresh(), og
   handlekurvsiden lastes på nytt. */
(function () {
  if (customElements.get('im-gaveinnpakning')) return;
  var rot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ventende = null; /* pågående lagring av hilsen */

  function post(sti, body) {
    return fetch(rot + sti, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Handlekurven svarte ' + r.status);
      return r.json();
    });
  }
  function hentKurv() {
    return fetch(rot + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function oppdater(kilde) {
    var skuff = document.querySelector('g9-cart-drawer');
    if (kilde === 'skuff' && skuff && typeof skuff.refresh === 'function') return skuff.refresh();
    window.location.reload();
  }
  /* Bare ett rydde-/fjerneforsøk per sidevisning, så en feil ikke gir en løkke av omlastinger. */
  function forsokEnGang(nokkel) {
    try {
      if (sessionStorage.getItem(nokkel)) return false;
      sessionStorage.setItem(nokkel, '1');
      setTimeout(function () { try { sessionStorage.removeItem(nokkel); } catch (e) {} }, 10000);
    } catch (e) {}
    return true;
  }

  /* «Til kassen» (skuff og handlekurvside): vent på hilsen som lagres. */
  document.addEventListener('submit', function (e) {
    var knapp = e.submitter;
    if (!ventende || !knapp || knapp.name !== 'checkout') return;
    e.preventDefault();
    ventende.finally(function () { window.location.href = rot + 'checkout'; });
  }, true);

  class ImGaveinnpakning extends HTMLElement {
    connectedCallback() {
      var kilde = this.dataset.kilde;
      if (this.hasAttribute('data-fjern')) {
        if (!forsokEnGang('im-gave-fjern')) return;
        post('cart/change.js', { id: this.dataset.linje, quantity: 0 }).then(function () { return oppdater(kilde); }).catch(function () {});
        return;
      }
      if (this.hasAttribute('data-rydd') && forsokEnGang('im-gave-rydd')) this.rydd();
      this.boks = this.querySelector('[data-im-gave-boks]');
      this.hilsen = this.querySelector('[data-im-gave-hilsen]');
      if (this.boks) this.boks.addEventListener('change', this.vedValg.bind(this));
      if (this.hilsen) {
        var self = this, tid = null;
        /* Sist lagrede hilsen står på tekstfeltet (data-lagret) fra Liquid. */
        this.dataset.lagret = this.hilsen.getAttribute('data-lagret') || '';
        this.hilsen.addEventListener('input', function () {
          clearTimeout(tid);
          tid = setTimeout(function () { self.lagreHilsen(); }, 600);
        });
        this.hilsen.addEventListener('change', function () { clearTimeout(tid); self.lagreHilsen(); });
      }
    }
    rydd() {
      var v = Number(this.dataset.variant), kilde = this.dataset.kilde;
      hentKurv().then(function (kurv) {
        var linjer = (kurv.items || []).filter(function (i) { return i.variant_id === v; });
        /* Behold linjen som har en hilsen, om det finnes en. */
        linjer.sort(function (a, b) { return (b.properties && b.properties.Gavehilsen ? 1 : 0) - (a.properties && a.properties.Gavehilsen ? 1 : 0); });
        var endringer = {};
        linjer.forEach(function (l, n) { endringer[l.key] = n === 0 ? 1 : 0; });
        return post('cart/update.js', { updates: endringer });
      }).then(function () { return oppdater(kilde); }).catch(function () {});
    }
    vedValg() {
      var self = this, kilde = this.dataset.kilde, linje = this.dataset.linje;
      this.boks.disabled = true;
      var p = this.boks.checked
        ? post('cart/add.js', { items: [{ id: Number(this.dataset.variant), quantity: 1 }] })
        : (linje ? post('cart/change.js', { id: linje, quantity: 0 }) : Promise.resolve());
      p.then(function () { return oppdater(kilde); })
        .catch(function () { self.boks.checked = !self.boks.checked; })
        .finally(function () { self.boks.disabled = false; });
    }
    lagreHilsen() {
      var self = this, linje = this.dataset.linje;
      if (!linje) return;
      var tekst = this.hilsen.value.trim().slice(0, 200);
      var v = Number(self.dataset.variant);
      if (tekst === (this.dataset.lagret || '')) return;
      var status = self.querySelector('[data-im-gave-lagret]');
      /* Variant-id i stedet for linjenøkkel: nøkkelen endres når egenskapene endres, og to
         lagringer som overlapper ville ellers sendt en utdatert nøkkel. Etter rydding finnes
         det bare én innpakningslinje. */
      var p = post('cart/change.js', { id: String(v), quantity: 1, properties: { Gavehilsen: tekst } })
        .then(function (kurv) {
          /* Linjenøkkelen endres når egenskapene endres. */
          var ny = (kurv.items || []).filter(function (i) { return i.variant_id === v; })[0];
          document.querySelectorAll('im-gaveinnpakning').forEach(function (a) { if (ny) a.dataset.linje = ny.key; a.dataset.lagret = tekst; });
          if (status) { status.textContent = 'Lagret'; status.hidden = false; setTimeout(function () { status.hidden = true; }, 2000); }
        })
        .catch(function () {
          if (status) { status.textContent = 'Hilsenen ble ikke lagret. Prøv igjen.'; status.hidden = false; }
        });
      ventende = p.finally(function () { if (ventende === q) ventende = null; });
      var q = ventende;
      return p;
    }
  }
  customElements.define('im-gaveinnpakning', ImGaveinnpakning);
})();
